export enum SearchableStrapiEntities {
  'experts' = 'expert',
  'partners' = 'apps_courses',
}

export interface SearchHit {
  id: number;
  title: string;
  description: string;
  type: SearchableStrapiEntities;
}
